import { onScopeDispose } from 'vue';
import type { Subscription } from 'dexie';

export const useAutoUnsubscribe = () => {
  const subscriptions: Subscription[] = [];
  /**
   * Track a subscription for auto-unsubscribe on scope disposal.
   * @param Subscription
   * @returns The same subscription passed in.
   */
  const trackSubscription = (sub: Subscription): Subscription => {
    if (typeof sub.unsubscribe === 'function') subscriptions.push(sub);
    return sub;
  };

  /**
   * Track multiple subscriptions for auto-unsubscribe on scope disposal.
   * @param Subscription[]
   * @returns The same subscriptions passed in.
   */
  const trackMultipleSubscriptions = (subs: Subscription[]): Subscription[] => {
    subs.forEach((s) => {
      if (s && typeof s.unsubscribe === 'function') subscriptions.push(s);
    });
    return subs;
  };

  /**
   * Clear all tracked subscriptions.
   */
  const clear = () => {
    for (const s of subscriptions)
      try {
        s.unsubscribe();
      } catch {
        // No-op
      }
    subscriptions.length = 0;
  };

  onScopeDispose(clear); // Auto-clean when current scope is disposed (component or composable).

  return { trackSubscription, trackMultipleSubscriptions };
};
